export default interface FigmaSyncData {
    figmaSyncRedirectData?: FigmaSyncRedirectData;
    figmaSyncErrorData?: FigmaSyncErrorData;
}

export interface FigmaSyncRedirectData {
    updatedFigmaFileId?: string;
    figmaFileId: string;
}

export enum FigmaSyncErrorType {
    Custom = "Custom",
    ImportCompletedWithIssues = "ImportCompletedWithIssues"
}

export interface FigmaSyncErrorData {
    errorType: FigmaSyncErrorType;
    title: string;
    message: string;
}

export interface FigmaSyncProgressInfo {
    isSyncing?: boolean;
}

export interface FigmaSyncUpdateFile {
    figmaFileName: string;
    isOutOfSync: boolean;
    isSyncing?: boolean;
}

export interface FigmaSyncImportData {
    figmaFileKey: string;
    figmaFileName: string;
    isSyncing?: boolean;
}

export interface FigmaSyncUrlData {
    createdStyleguideId?: string;
    figmaKey: string;
}
